import { render } from "./SliderPainter.vue?vue&type=template&id=bac65cc8&scoped=true"
import script from "./SliderPainter.vue?vue&type=script&lang=js"
export * from "./SliderPainter.vue?vue&type=script&lang=js"

import "./SliderPainter.vue?vue&type=style&index=0&id=bac65cc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Mudassir\\Retrocausal\\portal_frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bac65cc8"]])

export default __exports__